/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMessageAutocompleteSuggestion } from './APIMessageAutocompleteSuggestion';
import {
    APIMessageAutocompleteSuggestionFromJSON,
    APIMessageAutocompleteSuggestionFromJSONTyped,
    APIMessageAutocompleteSuggestionToJSON,
} from './APIMessageAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIMessageAutocompleteResponse
 */
export interface APIMessageAutocompleteResponse {
    /**
     * 
     * @type {Array<APIMessageAutocompleteSuggestion>}
     * @memberof APIMessageAutocompleteResponse
     */
    suggestions: Array<APIMessageAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIMessageAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIMessageAutocompleteResponse interface.
 */
export function instanceOfAPIMessageAutocompleteResponse(value: object): value is APIMessageAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIMessageAutocompleteResponseFromJSON(json: any): APIMessageAutocompleteResponse {
    return APIMessageAutocompleteResponseFromJSONTyped(json, false);
}

export function APIMessageAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIMessageAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIMessageAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIMessageAutocompleteResponseToJSON(value?: APIMessageAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIMessageAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

